import { EMPTY_LIST } from '../../../../constants/common'
import { useAsyncEntity } from '../../../Entity'
import { getMockIntegrationsStatus } from '../../RentalPortalListing.mocks'

export function useRentalPortalListingPortalConnections() {
  // TODO: the backend serves no portal connections yet, so they come from the mock
  const { entityData, handleEntityReload, isLoading, serverError } =
    useAsyncEntity({ getProfileData: getMockIntegrationsStatus })

  return {
    handleReloadPortals: handleEntityReload,
    hasPortalsError: Boolean(serverError),
    isLoadingPortals: isLoading,
    portals: entityData?.portals ?? EMPTY_LIST,
  }
}
